// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICardStatusSummaryRecordDto } from './ICardStatusSummaryRecordDto';
import {
    ICardStatusSummaryRecordDtoFromJSON,
    ICardStatusSummaryRecordDtoFromJSONTyped,
    ICardStatusSummaryRecordDtoToJSON,
    ICardStatusSummaryRecordDtoToJSONTyped,
} from './ICardStatusSummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryGroupDtoCardStatusSummaryRecordDto
 */
export interface IReportSummaryGroupDtoCardStatusSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryGroupDtoCardStatusSummaryRecordDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {Array<ICardStatusSummaryRecordDto>}
     * @memberof IReportSummaryGroupDtoCardStatusSummaryRecordDto
     */
    subsidiary_records?: Array<ICardStatusSummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryGroupDtoCardStatusSummaryRecordDto interface.
 */
export function instanceOfIReportSummaryGroupDtoCardStatusSummaryRecordDto(value: object): value is IReportSummaryGroupDtoCardStatusSummaryRecordDto {
    return true;
}

export function IReportSummaryGroupDtoCardStatusSummaryRecordDtoFromJSON(json: any): IReportSummaryGroupDtoCardStatusSummaryRecordDto {
    return IReportSummaryGroupDtoCardStatusSummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryGroupDtoCardStatusSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryGroupDtoCardStatusSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'subsidiary_records': json['subsidiary_records'] == null ? undefined : ((json['subsidiary_records'] as Array<any>).map(ICardStatusSummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryGroupDtoCardStatusSummaryRecordDtoToJSON(json: any): IReportSummaryGroupDtoCardStatusSummaryRecordDto {
    return IReportSummaryGroupDtoCardStatusSummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryGroupDtoCardStatusSummaryRecordDtoToJSONTyped(value?: IReportSummaryGroupDtoCardStatusSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subsidiary_name': value['subsidiary_name'],
        'subsidiary_records': value['subsidiary_records'] == null ? undefined : ((value['subsidiary_records'] as Array<any>).map(ICardStatusSummaryRecordDtoToJSON)),
    };
}

